import React, { Fragment, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import NumberFormat from "react-number-format";
import Swal from 'sweetalert2';
import DatePicker, { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { setParametrosBusqueda } from "../../actions/busqueda/busquedaAction";
import Spinner from "../../components/Spinner";
import { requests } from "../../constants/config";
import { EXITO, ERROR_FACTURA } from "../../constants/enviroment";
import useForm from "../../hooks/useForm";
import axios from "../../axios";
import { facturaMotoConstraints, facturaMotoForm } from "./FacturaMotoForm";

registerLocale('es', es);

const BusquedaOperacionMoto = (props) => {
    const dispatch = useDispatch();
    const tiendas = useSelector(state => state.tiendas);
    const [buscando, setIsBuscando] = useState(false);
    const [error, setErrores] = useState('');

    const {
        form,
        handleFormChange,
        isFormValid,
        getValue
    } = useForm(facturaMotoForm, facturaMotoConstraints);

    const setForm = async (event) => {
        handleFormChange(event);
    };

    const disabledButton = () => {
        return !isFormValid();
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsBuscando(true);
        setErrores('');
    
        const dateFormat = {day:'numeric', month:'numeric', year:'numeric'}
        let data = {
            type: 'T',
            operationNumber: parseInt(getValue("oprcaj")),
            location: parseInt(getValue("cvetda")),
            total: Number(getValue("importe").replace(/[\$,]/g, '')),
            tranDate: getValue("fechaCompra").toLocaleDateString('es-ES', dateFormat)
        }
        //console.log(data);
        axios.post(requests.facturacionMoto.validarOperacion, data)
        .then(res => {
            console.log(res.data);
            let idNetsuite = res.data.idNetsuite;
            let code = res.data.mensaje.codigo;
            let mensaje = res.data.mensaje.descripcion;
            let parametrosBusqueda = {
                ...form.values,
                idNetsuite,
                mensaje
            }
            dispatch(setParametrosBusqueda(parametrosBusqueda));
            setIsBuscando(false);
            
            //console.log(res.data);
            if (code === EXITO) {
                props.nextStep();
            } else if(code === ERROR_FACTURA) {
                notificarErrorFactura();
            } else {
                setErrores(mensaje);
            }
        }).catch((err) => {
            setIsBuscando(false);
            setErrores('Ocurrió un error, verifique sus datos de búsqueda.');
        });
    };

    const notificarErrorFactura = () => {
        Swal.fire({
            title: '<strong>FACTURACION NO VALIDA</strong>',
            padding: '2em',
            html: '<p align="justify">Estimado cliente se le informa que las compras de:</p>' +
                  '<div align="left"><ul><li>Tarjetas de beneficencia o redondeo de kilo de ayuda</li>' +
                  '<li>Pago de servicios (Luz, Direct TV, etc)</li>' +
                  '<li>Compra de seguros</li>' + 
                  '<li>Préstamos de efectivo</li>' +
                  '<li>Óptica Devlyn</li></ul></div>' +
                  '<strong>NO SON FACTURABLES.</strong>' +
                  '<p align="justify">Si en su compra usted incluyó alguno de estos artículos, <b>para facturar deberá descontarlos del importe total</b> de su nota.<br>' + 
                  'Si requiere factura de alguno de esos artículos, <b>deberá acudir directamente al proveedor</b> de los mismos.<br><br>' +
                  ' En caso de duda, favor de comunicarse al <b>Centro de Atención Telefónica</b> al número <a href="tel:(999) 30-28-00"><strong>9999302800</strong></a>, envíe un <b>correo</b> a <a href="mailto:facturacion@chapur.com"><strong>facturacion@chapur.com</strong></a> o envíe <b>Whatsapp</b> al número <a href="tel:(999) 30-28-20"><strong>9999302820</strong></a></p>.'
        })
    };

    return (
        <Fragment>
            <h3>Ingrese la información para facturar la motocicleta</h3>
            <p>Consulte la información de la compra en el <strong>Ticket</strong>.</p>
            {/*<div className="mb-40">
                <a className="btn btn--large btn-info"
                    href="/">Preguntas frecuentes {' '} 
                        <FontAwesomeIcon className="feature-box__icon feature-box__icon--small"
                                        icon={faInfoCircle}/>
                </a>
            </div>*/}
            
            {(error !== null && error !== '') ?
                <div className="alert alert-warning" role="alert">
                    <FontAwesomeIcon className="feature-box__icon feature-box__icon--small"
                                     icon={faExclamationTriangle}/> {error}
                </div> : ''
            }

            <form onSubmit={handleSubmit}>
                <div className="form-row">
                    <div className="form-group col-xs-12 col-md-6">
                        <div>
                            <label htmlFor="cvetda">Tienda*:</label>
                            {/*<button type='button' className='btn btn-help' onClick={() => Alert(GENERAL_TIENDA, 'Tienda', 300)}>
                                <FontAwesomeIcon className="feature-box__icon feature-box__icon--small"
                                                icon={faQuestionCircle}/>
                            </button>*/}
                        </div>
                        <select
                            className="form-control" id="cvetda" name="cvetda"
                            value={getValue('cvetda') || '0'}
                            onChange={setForm}
                            disabled={buscando}
                        >
                            <option key={-1} value="0" disabled>Seleccionar tienda</option>
                            {tiendas.tiendas != null && tiendas.tiendas.map((tienda, i) => (
                                <option key={i} value={tienda.cvetda}>{tienda.nombre}</option>
                            ))}
                        </select>
                    </div>
                    <div className="form-group col-xs-12 col-md-6">
                        <div>
                            <label htmlFor="oprcaj">Operación*:</label>
                            {/*<button type='button' className='btn btn-help' onClick={() => Alert(GENERAL_OPERACION, 'Operación', 300)}>
                                <FontAwesomeIcon className="feature-box__icon feature-box__icon--small"
                                                icon={faQuestionCircle}/>
                            </button>*/}
                        </div>
                        <NumberFormat
                            className="form-control" id="oprcaj" name="oprcaj"
                            value={getValue('oprcaj') || ''}
                            onChange={setForm}
                            disabled={buscando}
                            allowNegative={false}
                            placeholder="Operación de caja"
                            maxLength="10"
                            autoComplete="off"
                            decimalScale="0"
                            decimalSeparator={false}
                        />
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-group col-xs-12 col-md-6">
                        <div>
                            <label htmlFor="fechaCompra">Fecha*:</label>
                            {/*<button type='button' className='btn btn-help' onClick={() => Alert(GENERAL_FECHA, 'Fecha', 300)}>
                                <FontAwesomeIcon className="feature-box__icon feature-box__icon--small"
                                                icon={faQuestionCircle}/>
                            </button>*/}
                        </div>
                        <DatePicker 
                            className="form-control" id="fechaCompra" name="fechaCompra"
                            selected={getValue('fechaCompra')} 
                            value={getValue('fechaCompra') || ''}
                            onChange={setForm}
                            disabled={buscando}
                            dateFormat="dd-MM-yyyy"
                            maxDate={new Date()}
                            autoComplete="off"
                            locale="es" 
                        />
                    </div>
                    <div className="form-group col-xs-12 col-md-6">
                        <div>
                            <label htmlFor="importe">Importe*:</label>
                            {/*<button type='button' className='btn btn-help' onClick={() => Alert(GENERAL_IMPORTE, 'Importe', 300)}>
                                <FontAwesomeIcon className="feature-box__icon feature-box__icon--small"
                                                icon={faQuestionCircle}/>
                            </button>*/}
                        </div>
                        <NumberFormat
                            className="form-control" id="importe" name="importe"
                            value={getValue('importe') || ''}
                            onChange={setForm}
                            disabled={buscando}
                            allowNegative={false}
                            placeholder="Importe de la operación"
                            maxLength="11"
                            autoComplete="off"
                            thousandSeparator={true}
                            prefix={'$'}  
                        />
                    </div>
                </div>

                <button type="submit" className="btn btn-lg btn-chapur btn-block mt-30"
                        disabled={buscando || disabledButton()}>
                    {!buscando ? 'Buscar' : 'Buscando...'}
                    {buscando && <Spinner/>}
                </button>
            </form>
        </Fragment>
    );
};

export default BusquedaOperacionMoto;